import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
  padding: 24px 16px;
`;
const AllCheckBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;
const Button = styled.span<{ active?: boolean }>`
  width: 74px;
  height: 38px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => (props.active ? '#616161' : 'rgba(55, 56, 60, 0.16)')};
  border-radius: 8px;
  background-color: ${(props) =>
    props.active ? 'rgba(112, 115, 124, 0.08)' : ' #f7f7f8'};
`;

const ListBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-top: 1px solid #e1e2e4;
`;
const ListHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  background-color: #f7f8fc;
  border-bottom: 1px solid #e1e2e4;
`;
const ListHeaderItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  color: #616161;
  flex-wrap: wrap;
`;

const List = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ListRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`;

const ListRow2 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #e1e2e4;
`;
const RowItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #222;
`;
const PatternBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
`;
const Number = styled.span`
  width: 24px;
  height: 24px;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  color: #616161;
  border-radius: 2px;
  background-color: rgba(112, 115, 124, 0.08);
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Patterns = styled.div`
  width: 100%;
  font-size: 12px;
  font-weight: 500;
  color: #616161;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;
const ResultButton = styled.button`
  padding: 9px 20.5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #008aff;
  background-color: #fff;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #008aff;
  cursor: pointer;
  text-wrap: nowrap;
`;
const SaveButton = styled.button`
  padding: 9px 20.5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: #008aff;
  border: none;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #fff;
  cursor: pointer;
  text-wrap: nowrap;
`;
const DateBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  color: #616161;
`;
const Tag = styled.div<{ grade: number }>`
  padding: 0px 8px;
  height: 29px;
  border-radius: 4px;
  background: ${(props) =>
    props.grade === 1 ? '#FFEFEF' : props.grade === 2 ? '#EEFFF6' : '#EAF2FE'};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  color: #008aff;
  line-height: 145%;
`;
const EmptyList = styled.div`
  width: 100%;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #222;
  border-bottom: 1px solid #e1e2e4;
`;
const PlusBox = styled.div`
  padding: 16px 24px;
  height: 56px;
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  border: 1px dashed #e1e2e4;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
`;
export const s = {
  Container,
  AllCheckBox,
  Button,
  ListBox,
  ListHeader,
  ListHeaderItem,
  List,
  ListRow,
  ListRow2,
  RowItem,
  PatternBox,
  Number,
  Patterns,
  ResultButton,
  DateBox,
  Tag,
  EmptyList,
  PlusBox,
  SaveButton,
};
